export * from './alert-icon'
export * from './arrow-icon'
export * from './info-icon'
export * from './alarm-icon'
export * from './victory-icon'
export * from './facebook-icon'
export * from './twitter-icon'
export * from './whatsapp-icon'
export * from './sad-icon'
export * from './play-icon'
export * from './share-icon'
export * from './cross-icon'
export * from './chain-icon'
